export default "__VITE_ASSET__cp_dURzC__"